import React from "react"
import ReactDOM from 'react-dom'
import Ample from "../components/ample"
import {formatCurrency} from "../components/utils"
import ExpirySelector from "../components/expiryselector"
import TickerDropDown from "../components/tickerdropdown"
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { OutboundLink } from "gatsby-plugin-google-gtag"

export default class MaxPainPage extends React.Component {
  SortMode = {
    Strike:0, PutInterest:1, CallInterest:2, CumulativeLiability:3
  }
  state = {
    ticker: "CHWY",
    expiry: "",
    resultsVisible : false,
    optiondata: null,
    backdropActive:false
  }
  formValid() {
    return ((this.state.ticker.trim() !== "") && (this.state.expiry.trim() !== ""))
  }
  tickerChanged = newTicker => {
    this.setState({ticker:newTicker})
  }
  expiryChanged = newExpiry => {
      this.setState({expiry:newExpiry})
  }
  activateBackdrop = () => {
    this.setState({backdropActive:true})
  }
  closeBackdrop = () => {
    this.setState({backdropActive:false})
  }
  
  formReset = event => {
    this.setState({resultsVisible:false})
  }
  formSubmitted = event => {
    this.setState({resultsVisible:false})
    this.requestOptionData()
  }
  requestOptionData() {
    const url = `https://api.harsip.com/options/${this.state.ticker}/max-pain?expiry=${this.state.expiry}`

    this.activateBackdrop()
    fetch(url)
        .then(res => res.json())
        .then((data) => {
          this.setState({ optiondata: data })
          this.sortData(this.SortMode.CumulativeLiability)
          this.renderOptionsTable()
        }).then ( ()=> {this.closeBackdrop()} )
        .catch(console.log)
  }
  sortData(mode) {
      let data = this.state.optiondata

      switch (mode) {
        case this.SortMode.Strike:
          data.sort( (a,b) => b.strike - a.strike )
          break
        case this.SortMode.PutInterest:
          data.sort( (a,b) => b.putInterest - (a.putInterest)  )
          break
        case this.SortMode.CallInterest:
          data.sort( (a,b) =>  (b.callInterest) - (a.callInterest))
          break
        default:
          data.sort( (a,b) => a.CumulativeLiability - b.CumulativeLiability )
      }
      this.setState({optiondata:data})
  }
  requestSort = (mode) => {
      this.sortData(mode)
      this.renderOptionsTable() 
  }
   
  renderOptionsTable()  {
    let data=this.state.optiondata  
    let maxPainStyle = {
      backgroundColor:'#545b62',
      color: '#ffffff'
    }
    let optiondatatable= (
      <table width="100%" className="table"  >
      <thead>
        <tr>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.Strike)}>Strike&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.CallInterest)}>Call Interest&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.PutInterest)}>Put Interest&nbsp;<i className="fas fa-sort"></i></th>
          <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.CumulativeLiability)}>Cumulative Liability&nbsp;<i className="fas fa-sort"></i></th>
          </tr>
      </thead>
      <tbody>
      {
        data.map(opt=> {
          return (<tr key={opt.strike} style={ opt.IsMaxPain ? maxPainStyle : {}  }>
          <td>{opt.strike}</td>
          <td>{opt.callInterest}</td>
          <td>{opt.putInterest}</td>
          <td>{formatCurrency(opt.CumulativeLiability,0)}</td>
          </tr>)
        })
      }
      </tbody>
      </table>

    )
    ReactDOM.render(optiondatatable, document.getElementById('optionTable'));
    this.setState({resultsVisible:true})
  }
  


 explainerBlurb =<div>
   <OutboundLink href="https://www.investopedia.com/terms/m/maxpain.asp">MaxPain</OutboundLink> is based on Open Interest. Open Interest data and Put/Call Ratios are shown below the charts.
   </div>

  render() {
    return (
      <Ample currPageTitle="Max Pain Calculator" explainerBlurb={this.explainerBlurb}>
        <Backdrop style={{zIndex:  1,color: '#fff',}} open={this.state.backdropActive}  >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div className="white-box">
          <table>
            <tbody>
              <tr>
                <td><TickerDropDown defaultTicker={this.state.ticker}  onSelectedTickerChanged={this.tickerChanged} helperText="Select underlying company"/></td>
                <td><ExpirySelector ticker={this.state.ticker} id="optionExpirySelector" onSelectedExpiryChange={this.expiryChanged} /></td>
              </tr>
            </tbody>
          </table>
          <br/>
          <button disabled={!this.formValid()} id="go" onClick={this.formSubmitted}  type="submit"  className="btn btn-rounded btn-default btn-outline">
            <i className="fas fa-play-circle  m-r-5"></i>Show</button>
          <button disabled={!this.state.resultsVisible} id="clear" onClick={this.formReset} className="btn btn-rounded btn-default btn-outline" >
            <i className="fas fa-eraser  m-r-5"></i>Clear</button>
        </div>

        <br />

        <div className="white-box" id="optionTableContainer" style={{visibility:(this.state.resultsVisible)?'visible':'hidden'}}>
        <div id="optionTable" className="table-responsive"></div>
        </div>
      </Ample>
    )
  }
}


